import Icon from '../../components/Icon.vue'

Icon.register({"brands/tumblr":{"width":320,"height":512,"paths":[{"d":"M309.8 480.3C296.2 494.8 259.8 512 212.4 512 91.6 512 65.4 423.2 65.4 371.4V227.4H17.9C12.4 227.4 7.9 222.9 7.9 217.4V149.4C7.9 142.2 12.4 135.8 19.2 133.4 81.2 111.6 100.7 57.4 103.5 16.3 104.3 5.3 110 0 119.6 0H190.5C196 0 200.5 4.5 200.5 10V125.2H283.5C289 125.2 293.5 129.6 293.5 135.1V216.8C293.5 222.3 289 226.8 283.5 226.8H200.1V360C200.1 394.2 223.8 413.6 268.1 395.8 272.9 393.9 277.1 392.6 280.8 393.6 284.3 394.5 286.6 397 288.2 401.5L310.2 465.8C312 470.8 313.5 476.4 309.8 480.3z"}]}})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/brands/tumblr.js
// module id = RL1L
// module chunks = 0